document.documentElement.classList.add('js');

const header = document.querySelector('[data-header]');
const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 24);
updateHeader();
window.addEventListener('scroll', updateHeader, { passive: true });

document.querySelectorAll('[data-drawer-toggle]').forEach((button) => {
  button.addEventListener('click', () => {
    const open = document.body.classList.toggle('menu-open');
    button.setAttribute('aria-expanded', String(open));
  });
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const select = form.querySelector('[name="id"]');
  const price = form.querySelector('[data-product-price]');
  select?.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  });
});

const cartDrawerShell = document.querySelector('[data-cart-drawer]');
const cartDrawer = cartDrawerShell?.querySelector('.cart-drawer');
const cartItems = cartDrawerShell?.querySelector('[data-cart-items]');
const cartFooter = cartDrawerShell?.querySelector('[data-cart-footer]');
const cartSubtotal = cartDrawerShell?.querySelector('[data-cart-subtotal]');
const cartHeadingCount = cartDrawerShell?.querySelector('[data-cart-heading-count]');
const shopRoot = window.Shopify?.routes?.root || '/';
const shopCurrency = window.Shopify?.currency?.active || 'INR';

const formatMoney = (cents) => new Intl.NumberFormat('en-IN', {
  style: 'currency',
  currency: shopCurrency,
  maximumFractionDigits: 2
}).format(cents / 100);

const escapeCartText = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#039;'
}[character]));

const cartImageUrl = (url) => `${url}${url.includes('?') ? '&' : '?'}width=240`;

const updateCartBadges = (count) => {
  document.querySelectorAll('.cart-count').forEach((badge) => { badge.textContent = count; });
  document.querySelectorAll('.cart-icon-link').forEach((link) => {
    link.setAttribute('aria-label', `Cart, ${count} item${count === 1 ? '' : 's'}`);
  });
  if (cartHeadingCount) cartHeadingCount.textContent = `(${count})`;
};

const renderCart = (cart) => {
  if (!cartItems || !cartFooter) return;
  updateCartBadges(cart.item_count);
  if (!cart.item_count) {
    cartItems.innerHTML = `<div class="cart-drawer__empty"><p class="eyebrow">YOUR BAG IS EMPTY</p><h3>Find something made to last.</h3><a class="button button--solid" href="${shopRoot}collections/all">EXPLORE THE COLLECTION</a></div>`;
    cartFooter.hidden = true;
    return;
  }
  cartItems.innerHTML = cart.items.map((item, index) => {
    const image = item.image ? `<img src="${escapeCartText(cartImageUrl(item.image))}" alt="${escapeCartText(item.product_title)}" width="120" height="150" loading="lazy">` : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__variant">${escapeCartText(item.variant_title)}</p>` : '';
    return `<article class="cart-drawer__item">
      <a class="cart-drawer__image" href="${escapeCartText(item.url)}">${image}</a>
      <div class="cart-drawer__details">
        <a class="cart-drawer__title" href="${escapeCartText(item.url)}">${escapeCartText(item.product_title)}</a>
        ${variant}
        <strong class="cart-drawer__price">${formatMoney(item.final_line_price)}</strong>
        <div class="cart-drawer__item-actions">
          <div class="cart-drawer__quantity" aria-label="Quantity">
            <button type="button" data-cart-change data-line="${index + 1}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change data-line="${index + 1}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity">+</button>
          </div>
          <button class="cart-drawer__remove" type="button" data-cart-change data-line="${index + 1}" data-quantity="0">Remove</button>
        </div>
      </div>
    </article>`;
  }).join('');
  if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
  cartFooter.hidden = false;
};

const getCart = async () => {
  const response = await fetch(`${shopRoot}cart.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Unable to load cart');
  return response.json();
};

const openCartDrawer = async () => {
  if (!cartDrawerShell) return;
  document.body.classList.remove('menu-open');
  document.querySelectorAll('[data-drawer-toggle]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
  document.body.classList.add('cart-drawer-open');
  cartDrawerShell.setAttribute('aria-hidden', 'false');
  try {
    renderCart(await getCart());
  } catch {
    if (cartItems) cartItems.innerHTML = '<p>We could not load your bag. Please try again.</p>';
  }
  cartDrawer?.focus();
};

const closeCartDrawer = () => {
  if (!cartDrawerShell) return;
  document.body.classList.remove('cart-drawer-open');
  cartDrawerShell.setAttribute('aria-hidden', 'true');
};

document.querySelectorAll('.cart-icon-link').forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    openCartDrawer();
  });
});

cartDrawerShell?.addEventListener('click', async (event) => {
  const close = event.target.closest('[data-cart-close]');
  if (close) {
    closeCartDrawer();
    return;
  }
  const change = event.target.closest('[data-cart-change]');
  if (!change) return;
  change.disabled = true;
  try {
    const response = await fetch(`${shopRoot}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(change.dataset.line), quantity: Number(change.dataset.quantity) })
    });
    if (!response.ok) throw new Error('Unable to update cart');
    renderCart(await response.json());
  } catch {
    change.disabled = false;
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && document.body.classList.contains('cart-drawer-open')) closeCartDrawer();
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    try {
      const response = await fetch(`${shopRoot}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Unable to add item');
      await openCartDrawer();
    } catch {
      const feedback = form.querySelector('[data-cart-error]') || document.createElement('p');
      feedback.dataset.cartError = '';
      feedback.className = 'cart-error';
      feedback.textContent = 'We could not add this item. Please refresh and try again.';
      if (!feedback.parentNode) form.appendChild(feedback);
    } finally {
      if (submit) submit.disabled = false;
    }
  });
});

const currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
const cartPath = `${shopRoot.replace(/\/+$/, '')}/cart` || '/cart';
const obsoleteFrontpagePath = `${shopRoot.replace(/\/+$/, '')}/collections/frontpage` || '/collections/frontpage';
if (currentPath === obsoleteFrontpagePath) {
  window.location.replace(shopRoot);
} else if (currentPath === cartPath) {
  window.location.replace(`${shopRoot}?open_cart=1`);
} else {
  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get('open_cart') === '1') {
    currentUrl.searchParams.delete('open_cart');
    window.history.replaceState({}, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
    openCartDrawer();
  }
}

const accountDrawerShell = document.querySelector('[data-account-drawer]');
const accountDrawer = accountDrawerShell?.querySelector('.account-drawer');

const openAccountDrawer = () => {
  if (!accountDrawerShell) return;
  closeCartDrawer();
  document.body.classList.remove('menu-open');
  document.querySelectorAll('[data-drawer-toggle]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
  document.body.classList.add('account-drawer-open');
  accountDrawerShell.setAttribute('aria-hidden', 'false');
  accountDrawer?.focus();
};

const closeAccountDrawer = () => {
  if (!accountDrawerShell) return;
  document.body.classList.remove('account-drawer-open');
  accountDrawerShell.setAttribute('aria-hidden', 'true');
};

document.querySelectorAll('[data-account-open]').forEach((link) => {
  link.addEventListener('click', (event) => {
    event.preventDefault();
    openAccountDrawer();
  });
});

accountDrawerShell?.addEventListener('click', (event) => {
  if (event.target.closest('[data-account-close]')) closeAccountDrawer();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && document.body.classList.contains('account-drawer-open')) closeAccountDrawer();
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const mainImage = gallery.querySelector('.product-gallery__stage img');
  if (!mainImage) return;
  gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      mainImage.src = thumb.dataset.gallerySrc;
      mainImage.srcset = thumb.dataset.gallerySrc;
      mainImage.alt = thumb.dataset.galleryAlt || mainImage.alt;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => {
        const active = item === thumb;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
  });
});
